import useSWR from "swr"
import {API_ECP_PROJECTS} from "../constants/apiUrls"

export default function useCountEcpProjects(params) {
    const url = `${API_ECP_PROJECTS}/count?` + (params === "my-projects" ? "public=false" : params === "shared-projects" ? "public=true" : params === "recycle-bin" ? "deleted=true" : null)
    const {data, mutate, error} = useSWR(url)
    return {
        countEcpProjects: data,
        mutateCountEcpProjects: mutate,
        isLoadingCountEcpProjects: !error && !data,
        isErrorCountEcpProjects: error
    }
}